module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfront"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch1"
    }
  }, [_vm._v("1. I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")]), _vm._v(": D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFFERENT")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TORIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch1#ch1-1"
    }
  }, [_vm._v("A Story about the Ways of Power")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch1#ch1-2"
    }
  }, [_vm._v("A Dominant Story about the Separation of Church and State")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch2"
    }
  }, [_vm._v("2. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGINS OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWER")]), _vm._v(": T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERGENCE OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIANITY AND")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTISEMITISM")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch2#ch2-1"
    }
  }, [_vm._v("The New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch2#ch2-2"
    }
  }, [_vm._v("The Christian Discourse of Redefinition: An Excursus on Power")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch2#ch2-3"
    }
  }, [_vm._v("The Roman Establishment of Christianity: The First Crystallization of Church and State")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch3"
    }
  }, [_vm._v("3. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDDLE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GES")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch3#ch3-1"
    }
  }, [_vm._v("The Early Middle Ages")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch3#ch3-2"
    }
  }, [_vm._v("The Later Middle Ages")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch3#ch3-2-1"
    }
  }, [_vm._v("Christian Power and the Persecution of Jews")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch3#ch3-2-2"
    }
  }, [_vm._v("The Emerging Secular State")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENAISSANCE AND")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORMATION IN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTINENTAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UROPE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch4#ch4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Renaissance")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch4#ch4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lutheran Reformation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch4#ch4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Calvinist Reformation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORMATION")]), _vm._v(", C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVIL")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR, AND")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVOLUTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch5#ch5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The English Reformation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch5#ch5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Civil War, Restoration, and Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch5#ch5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("English Political Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch5#ch5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Church and State at the End of the Seventeenth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORTH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLONIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch6#ch6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Early Years: Calvinist Roots")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch6#ch6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christian Declension and Revival")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICAN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVOLUTION AND")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTITUTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch7#ch7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Revolution and Its Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch7#ch7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Constitution")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUITS OF THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAMING")]), _vm._v(": C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TATE IN")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INETEENTH-AND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLY")]), _vm._v("-T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WENTIETH")]), _vm._v("-C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTURY")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICA")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch8#ch8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nineteenth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch8#ch8-1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Development of Church and State")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch8#ch8-1-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Separation of Church and State in the Nineteenth Century: An Assessment")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch8#ch8-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Church and State in the Early Twentieth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUITS OF THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAMING")]), _vm._v(": C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TATE IN")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATE")]), _vm._v("-T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WENTIETH")]), _vm._v("-C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTURY")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICA")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch9#ch9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Supreme Court Intervenes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch9#ch9-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Brief Assessment of the Supreme Court Cases")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YNCHRONIC")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NALYSIS OF THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPARATION OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TATE IN THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WENTIETH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTURY")]), _vm._v(": C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCLUDING")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMARKS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Symbolic Power")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structural Power")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Interaction of Symbolic and Structural Power")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Thoughts: A Political Statement")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 78
// module chunks = 0